import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id')({
  beforeLoad: () => getTitleContextSlice('Dashboard Runs'),
  staticData: {
    owner: CodeOwner.Analytics,
  },
});
